const productRuntimeCopy=JSON.parse(document.getElementById('MoziProductRuntimeCopy').textContent);
const productRoot=document.querySelector('[data-mozi-page=product]');
// App-sourced ceramic covers; existing battery-to-journals choreography.
const journalNames = productRuntimeCopy.journalNames;
const journalArt = ['M004','M110','M012','M033','M104','M085','M111','M021','M106','M008'];
const sequence = document.querySelector('.journal-sequence');
const orbitField = document.querySelector('.orbit-field');
const squares = journalNames.map((name,index) => {
  const square = document.createElement('span');
  square.className = 'journal-square';
  square.dataset.label = name;
  const artwork = document.createElement('img');
  artwork.loading = 'lazy'; artwork.decoding = 'async';
  artwork.src = sequence.dataset.journalAssetTemplate.replace('M004', journalArt[index]);
  artwork.alt = '';
  artwork.width = 540; artwork.height = 540;
  square.append(artwork);
  document.querySelector('.journal-squares').append(square);
  const label = document.createElement('span');
  label.textContent = name;
  document.querySelector('.journal-labels').append(label);
  return square;
});
const clampUnit = value => Math.max(0, Math.min(1, value));
const easeUnit = value => value * value * (3 - 2 * value);
function paintJournals() {
  const rect = sequence.getBoundingClientRect();
  if (rect.bottom < 0 || rect.top > innerHeight) return;
  const progress = clampUnit(-rect.top / Math.max(1, sequence.offsetHeight - innerHeight));
  const reveal = reduceMotion.matches ? 1 : easeUnit(clampUnit((progress - .15) / .55));
  sequence.style.setProperty('--scanner-scale', 1 - reveal * .40);
  sequence.style.setProperty('--battery-opacity', 1 - clampUnit(progress / .34));
  sequence.style.setProperty('--journal-opacity', reduceMotion.matches ? 1 : easeUnit(clampUnit((progress - .30) / .10)));
  const radius = Math.min(orbitField.clientWidth, orbitField.clientHeight) * (innerWidth <= 700 ? .38 : .49);
  squares.forEach((square, index) => {
    const angle = index / squares.length * Math.PI * 2 - Math.PI / 2 - (1 - reveal) * Math.PI;
    const inwardRotation = angle * 180 / Math.PI - 90;
    square.style.transform = 'translate(-50%, -50%) translate(' + Math.cos(angle) * radius * reveal + 'px,' + Math.sin(angle) * radius * reveal + 'px) rotate(' + inwardRotation + 'deg) scale(' + (.45 + reveal * .55) + ')';
    square.style.opacity = clampUnit(reveal * 3);
  });
}
const scanFeatures = Array.from(document.querySelectorAll('.skin-feature'));
function paintScanViews() {
  scanFeatures.forEach(feature => {
    const featureRect = feature.getBoundingClientRect();
    if (featureRect.bottom < 0 || featureRect.top > innerHeight) return;
    const copy = feature.querySelector('.skin-feature-copy');
    if (reduceMotion.matches) {
      copy.style.removeProperty('--copy-drift');
      copy.style.removeProperty('--copy-align');
      return;
    }
    if (innerWidth <= 700) {
      const height = feature.clientHeight;
      const progress = clampUnit((innerHeight - featureRect.top) / (height + innerHeight));
      const travel = Math.max(0, height - copy.offsetHeight - innerHeight * .15);
      copy.style.removeProperty('--copy-align');
      copy.style.setProperty('--copy-drift', (travel * progress).toFixed(2) + 'px');
      return;
    }
    const height = feature.clientHeight;
    const bottomPadding = parseFloat(getComputedStyle(feature).paddingBottom) || 0;
    const availableTravel = Math.max(0, height - bottomPadding - copy.offsetTop - copy.offsetHeight);
    const drift = Math.min(height * .7, availableTravel);
    const image = feature.querySelector('.visual-slot img');
    const featureTop = featureRect.top;
    const imageRect = image.getBoundingClientRect();
    const imageCenter = imageRect.top - featureTop + imageRect.height / 2;
    const copyCenter = copy.offsetTop + copy.offsetHeight / 2;
    // Keep the two centres together when the image passes the viewport midpoint.
    const midpointProgress = clampUnit((innerHeight / 2 + imageCenter) / (height + innerHeight));
    copy.style.setProperty('--copy-align', (imageCenter - copyCenter - drift * midpointProgress).toFixed(2) + 'px');
    // Start as the feature enters the viewport; the image keeps its normal scroll rate.
    const progress = clampUnit((innerHeight - featureTop) / (height + innerHeight));
    copy.style.setProperty('--copy-drift', (drift * progress).toFixed(2) + 'px');
  });
}
// Background transition only; product imagery remains static.
const lighting = document.querySelector('.lighting-study');
const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
let lightingFrame = false;
let lastDarkness = -1;
function paintLighting() {
  document.querySelector('.mozi-site-head')?.classList.toggle('is-scrolled', scrollY > 24);
  const rect = lighting.getBoundingClientRect();
  const viewport = innerHeight;
  const entering = Math.min(1, Math.max(0, (viewport - rect.top) / (viewport * .8)));
  const leaving = Math.min(1, Math.max(0, rect.bottom / (viewport * .8)));
  const progress = Math.min(entering, leaving);
  const darkness = reduceMotion.matches ? 1 : progress * progress * (3 - 2 * progress);
  if (Math.abs(darkness - lastDarkness) > .0001) {
    lastDarkness = darkness;
    lighting.style.setProperty('--darkness', darkness.toFixed(4));
    const blend = (light, dark) => light.map((value, i) => Math.round(value + (dark[i] - value) * darkness)).join(',');
    lighting.style.setProperty('--lighting-ink', blend([48,52,45], [245,245,243]));
    lighting.style.setProperty('--lighting-muted', blend([98,102,95], [182,185,189]));
    document.documentElement.style.setProperty('--page-background', blend([241,237,228], [17,19,22]));
    document.documentElement.style.setProperty('--page-ink', blend([48,52,45], [245,245,243]));
  }
  lightingFrame = false;
  paintScanViews();
  paintJournals();
}
function queueLighting() {
  if (!lightingFrame) { lightingFrame = true; requestAnimationFrame(paintLighting); }
}
addEventListener('scroll', queueLighting, {passive:true});
addEventListener('resize', queueLighting);
reduceMotion.addEventListener('change', queueLighting);
// Native source: JournalMeasurementCarousel.swift / MetricPaperArtwork.swift.
// Values are design fixtures, never scan results. Paper uses the native non-Metal fallback.
const metricFixtures = [
  ['spot_count','Visible spots','12','count','paper'],
  ['spot_density','Spots per cm²','3.0','count/cm²','tokens'],
  ['spot_area_fraction','Spot coverage','4.2','% of valid area','paper'],
  ['mark_area_fraction','Mark coverage','8.4','% of valid area','sector'],
  ['mark_contrast','Mark contrast','0.24','index','paper'],
  ['red_area_fraction','Redness coverage','12.5','% of valid area','sector'],
  ['red_contrast','Redness contrast','0.18','index','contrast'],
  ['pore_count','Visible pores','24','count','tokens'],
  ['pore_density','Pores per cm²','4.5','count/cm²','tokens'],
  ['pore_area_fraction','Pore coverage','6.8','% of valid area','sector'],
  ['microtexture_contrast','Fine texture contrast','0.32','index','contrast'],
  ['surface_uniformity','Texture evenness','0.68','index','contours'],
  ['line_count','Visible lines','7','count','paper'],
  ['shine_intensity','Shine brightness','0.41','index','paper'],
  ['flake_area_fraction','Flaking coverage','2.6','% of valid area','sector']
];
function metricArtwork(id, value, unit, kind) {
  const gradient = 'ink-' + id;
  let shapes = '';
  if (kind === 'sector') {
    const angle = (-90 + value * 3.6) * Math.PI / 180;
    shapes = '<circle cx="90" cy="60" r="48" fill="currentColor" opacity=".08"/><path d="M90 60 L90 12 A48 48 0 ' + (value > 50 ? 1 : 0) + ' 1 ' + (90 + 48 * Math.cos(angle)) + ' ' + (60 + 48 * Math.sin(angle)) + ' Z" fill="url(#' + gradient + ')"/><circle cx="90" cy="60" r="48" fill="none" stroke="currentColor" opacity=".22"/>';
  } else if (kind === 'tokens') {
    const count = Math.min(40, Math.round(unit === 'count/cm²' ? value * 4 : value));
    for (let i = 0; i < count; i++) {
      const a = i * 2.399963, r = .55 + .35 * Math.sin(i * 1.73 + .6);
      shapes += '<circle cx="' + (90 + Math.cos(a) * r * 77) + '" cy="' + (60 + Math.sin(a) * r * 50) + '" r="5" ' + (id.startsWith('pore') ? 'fill="none" stroke="url(#' + gradient + ')" stroke-width="1.8"' : 'fill="url(#' + gradient + ')"') + '/>';
    }
    if (unit === 'count/cm²') shapes += '<path d="M20 10H8V22 M160 10H172V22 M8 98V110H20 M160 110H172V98" fill="none" stroke="currentColor" opacity=".25"/>';
  } else if (kind === 'contrast') {
    for (let i = 0; i < 3; i++) shapes += '<circle cx="' + (54 + i * 36) + '" cy="60" r="37" fill="url(#' + gradient + ')" opacity="' + (.2 + i * .15) + '"/>';
  } else {
    for (let i = 0; i < 12; i++) {
      const y = 18 + i * 6.6;
      shapes += '<path d="M0 ' + (y + 18) + ' C58 ' + (y - 44) + ' 119 ' + (y + 52) + ' 180 ' + (y - 4) + '" fill="none" stroke="url(#' + gradient + ')" stroke-width="' + (i % 4 === 0 ? 2 : 1) + '"/>';
    }
  }
  return '<svg viewBox="0 0 180 120" aria-hidden="true"><defs><linearGradient id="' + gradient + '" x2="1" y2="1"><stop stop-color="currentColor" stop-opacity=".15"/><stop offset=".5" stop-color="currentColor" stop-opacity=".9"/><stop offset="1" stop-color="currentColor" stop-opacity=".4"/></linearGradient></defs>' + shapes + '</svg>';
}
const metricTrain = document.querySelector('.metric-train');
const metricCards = metricFixtures.map(([id, title, value, unit, kind]) => {
  title = productRuntimeCopy.metricTitles[id] || title;
  const card = document.createElement('article');
  card.className = 'metric-card native-metric native-metric--grid';
  card.dataset.metricId = id;
  card.dataset.valueSource = 'illustrative';
  const lower = metricFixtures.findIndex(metric => metric[0] === id) % 2 === 0;
  const displayValue = value + (unit === '% of valid area' ? '%' : unit === 'count/cm²' ? '/cm²' : '');
  card.innerHTML = '<div class="native-metric-copy"><h3>' + title + '</h3><strong>' + displayValue + '</strong></div><div class="metric-comparison"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="' + (lower ? 'M8 2V14 M3 9L8 14L13 9' : 'M8 14V2 M3 7L8 2L13 7') + '"/></svg><span>' + (unit === 'count' ? '2' : '0.1') + (unit === '% of valid area' ? '%' : unit === 'count/cm²' ? '/cm²' : '') + '</span></div>';
  return card;
});
const metricSet = document.createElement('div');
metricSet.className = 'product-metric-set';
metricSet.append(...metricCards);
const repeatedMetricSet = metricSet.cloneNode(true);
repeatedMetricSet.setAttribute('aria-hidden', 'true');
metricTrain.replaceChildren(metricSet, repeatedMetricSet);
paintLighting();
const wipe = document.querySelector('.wipe-control');
wipe.addEventListener('input', () => {
  wipe.parentElement.style.setProperty('--split', wipe.value + '%');
});
const specColumn=document.querySelector('.specs>div:last-child');const specGrid=document.createElement('div');specGrid.className='spec-grid';specColumn.querySelectorAll('details').forEach(d=>{const group=document.createElement('article');const title=document.createElement('h3');title.textContent=d.querySelector('summary').textContent;const copy=document.createElement('p');copy.append(...Array.from(d.querySelector('p').childNodes, node=>node.cloneNode(true)));group.append(title,copy);specGrid.append(group);d.remove()});specColumn.append(specGrid);

